import React from 'react';

/** No leídos de una pestaña de Recibidos (bug 3): sin esto el badge decía 10 y ninguna pestaña decía
 *  dónde estaban. Nada si no hay. `conteo` = `pestanas` de /mail/unified (los cuenta el backend). */
export default function ConteoPestana({ conteo, id }) {
  const n = conteo?.[id]?.unread || 0;
  if (n <= 0) return null;
  return (
    <span className="od-chip od-chip--inv" data-testid={`category-tab-unread-${id}`} aria-label={`${n} sin leer`}>
      {n}
    </span>
  );
}
